// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/common/currency.proto" (package "proto.common", syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/common/currency.proto" (package "proto.common", syntax proto3)
// tslint:disable
// ISO_4217
// https://www.currency-iso.org/dam/downloads/lists/list_one.xml

/**
 * @generated from protobuf enum proto.common.Currency
 */
export var Currency;

(function (Currency) {
  /**
   * protobuf comtatibility only
   *
   * @generated from protobuf enum value: UNKNOWN = 0;
   */
  Currency[Currency["UNKNOWN"] = 0] = "UNKNOWN";
  /**
   * Russian Ruble
   *
   * @generated from protobuf enum value: RUB = 643;
   */

  Currency[Currency["RUB"] = 643] = "RUB";
  /**
   * Euro
   *
   * @generated from protobuf enum value: EUR = 978;
   */

  Currency[Currency["EUR"] = 978] = "EUR";
  /**
   * US Dollar
   *
   * @generated from protobuf enum value: USD = 840;
   */

  Currency[Currency["USD"] = 840] = "USD";
  /**
   * Yuan Renminbi
   *
   * @generated from protobuf enum value: CNY = 156;
   */

  Currency[Currency["CNY"] = 156] = "CNY";
  /**
   * Yen
   *
   * @generated from protobuf enum value: JPY = 392;
   */

  Currency[Currency["JPY"] = 392] = "JPY";
  /**
   * Indian Rupee
   *
   * @generated from protobuf enum value: INR = 356;
   */

  Currency[Currency["INR"] = 356] = "INR";
  /**
   * Hryvnia
   *
   * @generated from protobuf enum value: UAH = 980;
   */

  Currency[Currency["UAH"] = 980] = "UAH";
  /**
   * Pound Sterling
   *
   * @generated from protobuf enum value: GBP = 826;
   */

  Currency[Currency["GBP"] = 826] = "GBP";
  /**
   * Canadian Dollar
   *
   * @generated from protobuf enum value: CAD = 124;
   */

  Currency[Currency["CAD"] = 124] = "CAD";
  /**
   * Swiss Franc
   *
   * @generated from protobuf enum value: CHF = 756;
   */

  Currency[Currency["CHF"] = 756] = "CHF";
  /**
   * Hong Kong Dollar
   *
   * @generated from protobuf enum value: HKD = 344;
   */

  Currency[Currency["HKD"] = 344] = "HKD";
  /**
   * Won
   *
   * @generated from protobuf enum value: KRW = 410;
   */

  Currency[Currency["KRW"] = 410] = "KRW";
  /**
   * Brazilian Real
   *
   * @generated from protobuf enum value: BRL = 986;
   */

  Currency[Currency["BRL"] = 986] = "BRL";
  /**
   * Mexican Peso
   *
   * @generated from protobuf enum value: MXN = 484;
   */

  Currency[Currency["MXN"] = 484] = "MXN";
  /**
   * Rand
   *
   * @generated from protobuf enum value: ZAR = 710;
   */

  Currency[Currency["ZAR"] = 710] = "ZAR";
  /**
   * Singapore Dollar
   *
   * @generated from protobuf enum value: SGD = 702;
   */

  Currency[Currency["SGD"] = 702] = "SGD";
  /**
   * Quetzal
   *
   * @generated from protobuf enum value: GTQ = 320;
   */

  Currency[Currency["GTQ"] = 320] = "GTQ";
  /**
   * Australian Dollar
   *
   * @generated from protobuf enum value: AUD = 36;
   */

  Currency[Currency["AUD"] = 36] = "AUD";
  /**
   * Danish Krone
   *
   * @generated from protobuf enum value: DKK = 208;
   */

  Currency[Currency["DKK"] = 208] = "DKK";
  /**
   * Iceland Krona
   *
   * @generated from protobuf enum value: ISK = 352;
   */

  Currency[Currency["ISK"] = 352] = "ISK";
  /**
   * New Taiwan Dollar
   *
   * @generated from protobuf enum value: TWD = 901;
   */

  Currency[Currency["TWD"] = 901] = "TWD";
  /**
   * Zloty
   *
   * @generated from protobuf enum value: PLN = 985;
   */

  Currency[Currency["PLN"] = 985] = "PLN";
  /**
   * Tenge
   *
   * @generated from protobuf enum value: KZT = 398;
   */

  Currency[Currency["KZT"] = 398] = "KZT";
  /**
   * Baht
   *
   * @generated from protobuf enum value: THB = 764;
   */

  Currency[Currency["THB"] = 764] = "THB";
  /**
   * New Zealand Dollar
   *
   * @generated from protobuf enum value: NZD = 554;
   */

  Currency[Currency["NZD"] = 554] = "NZD";
  /**
   * Norwegian Krone
   *
   * @generated from protobuf enum value: NOK = 578;
   */

  Currency[Currency["NOK"] = 578] = "NOK";
  /**
   * Czech Koruna
   *
   * @generated from protobuf enum value: CZK = 203;
   */

  Currency[Currency["CZK"] = 203] = "CZK";
  /**
   * Swedish Krona
   *
   * @generated from protobuf enum value: SEK = 752;
   */

  Currency[Currency["SEK"] = 752] = "SEK";
  /**
   * Forint
   *
   * @generated from protobuf enum value: HUF = 348;
   */

  Currency[Currency["HUF"] = 348] = "HUF";
  /**
   * Argentine Peso
   *
   * @generated from protobuf enum value: ARS = 32;
   */

  Currency[Currency["ARS"] = 32] = "ARS";
  /**
   * Turkish Lira
   *
   * @generated from protobuf enum value: TRY = 949;
   */

  Currency[Currency["TRY"] = 949] = "TRY";
  /**
   * New Israeli Sheqel
   *
   * @generated from protobuf enum value: ILS = 376;
   */

  Currency[Currency["ILS"] = 376] = "ILS";
  /**
   * Silver
   *
   * @generated from protobuf enum value: XAG = 961;
   */

  Currency[Currency["XAG"] = 961] = "XAG";
  /**
   * Gold
   *
   * @generated from protobuf enum value: XAU = 959;
   */

  Currency[Currency["XAU"] = 959] = "XAU";
  /**
   * UAE Dirham
   *
   * @generated from protobuf enum value: AED = 784;
   */

  Currency[Currency["AED"] = 784] = "AED";
  /**
   * Afghani
   *
   * @generated from protobuf enum value: AFN = 971;
   */

  Currency[Currency["AFN"] = 971] = "AFN";
  /**
   * Lek
   *
   * @generated from protobuf enum value: ALL = 8;
   */

  Currency[Currency["ALL"] = 8] = "ALL";
  /**
   * Armenian Dram
   *
   * @generated from protobuf enum value: AMD = 51;
   */

  Currency[Currency["AMD"] = 51] = "AMD";
  /**
   * Netherlands Antillean Guilder
   *
   * @generated from protobuf enum value: ANG = 532;
   */

  Currency[Currency["ANG"] = 532] = "ANG";
  /**
   * Kwanza
   *
   * @generated from protobuf enum value: AOA = 973;
   */

  Currency[Currency["AOA"] = 973] = "AOA";
  /**
   * Aruban Florin
   *
   * @generated from protobuf enum value: AWG = 533;
   */

  Currency[Currency["AWG"] = 533] = "AWG";
  /**
   * Azerbaijanian Manat
   *
   * @generated from protobuf enum value: AZN = 944;
   */

  Currency[Currency["AZN"] = 944] = "AZN";
  /**
   * Convertible Mark
   *
   * @generated from protobuf enum value: BAM = 977;
   */

  Currency[Currency["BAM"] = 977] = "BAM";
  /**
   * Barbados Dollar
   *
   * @generated from protobuf enum value: BBD = 52;
   */

  Currency[Currency["BBD"] = 52] = "BBD";
  /**
   * Taka
   *
   * @generated from protobuf enum value: BDT = 50;
   */

  Currency[Currency["BDT"] = 50] = "BDT";
  /**
   * Bulgarian Lev
   *
   * @generated from protobuf enum value: BGN = 975;
   */

  Currency[Currency["BGN"] = 975] = "BGN";
  /**
   * Bahraini Dinar
   *
   * @generated from protobuf enum value: BHD = 48;
   */

  Currency[Currency["BHD"] = 48] = "BHD";
  /**
   * Burundi Franc
   *
   * @generated from protobuf enum value: BIF = 108;
   */

  Currency[Currency["BIF"] = 108] = "BIF";
  /**
   * Bermudian Dollar
   *
   * @generated from protobuf enum value: BMD = 60;
   */

  Currency[Currency["BMD"] = 60] = "BMD";
  /**
   * Brunei Dollar
   *
   * @generated from protobuf enum value: BND = 96;
   */

  Currency[Currency["BND"] = 96] = "BND";
  /**
   * Boliviano
   *
   * @generated from protobuf enum value: BOB = 68;
   */

  Currency[Currency["BOB"] = 68] = "BOB";
  /**
   * Bahamian Dollar
   *
   * @generated from protobuf enum value: BSD = 44;
   */

  Currency[Currency["BSD"] = 44] = "BSD";
  /**
   * Ngultrum
   *
   * @generated from protobuf enum value: BTN = 64;
   */

  Currency[Currency["BTN"] = 64] = "BTN";
  /**
   * Pula
   *
   * @generated from protobuf enum value: BWP = 72;
   */

  Currency[Currency["BWP"] = 72] = "BWP";
  /**
   * Belarusian Ruble
   *
   * @generated from protobuf enum value: BYR = 974;
   */

  Currency[Currency["BYR"] = 974] = "BYR";
  /**
   * Belize Dollar
   *
   * @generated from protobuf enum value: BZD = 84;
   */

  Currency[Currency["BZD"] = 84] = "BZD";
  /**
   * Congolese Franc
   *
   * @generated from protobuf enum value: CDF = 976;
   */

  Currency[Currency["CDF"] = 976] = "CDF";
  /**
   * Chilean Peso
   *
   * @generated from protobuf enum value: CLP = 152;
   */

  Currency[Currency["CLP"] = 152] = "CLP";
  /**
   * Colombian Peso
   *
   * @generated from protobuf enum value: COP = 170;
   */

  Currency[Currency["COP"] = 170] = "COP";
  /**
   * Costa Rican Colon
   *
   * @generated from protobuf enum value: CRC = 188;
   */

  Currency[Currency["CRC"] = 188] = "CRC";
  /**
   * Cuban Peso
   *
   * @generated from protobuf enum value: CUP = 192;
   */

  Currency[Currency["CUP"] = 192] = "CUP";
  /**
   * Cabo Verde Escudo
   *
   * @generated from protobuf enum value: CVE = 132;
   */

  Currency[Currency["CVE"] = 132] = "CVE";
  /**
   * Djibouti Franc
   *
   * @generated from protobuf enum value: DJF = 262;
   */

  Currency[Currency["DJF"] = 262] = "DJF";
  /**
   * Dominican Peso
   *
   * @generated from protobuf enum value: DOP = 214;
   */

  Currency[Currency["DOP"] = 214] = "DOP";
  /**
   * Algerian Dinar
   *
   * @generated from protobuf enum value: DZD = 12;
   */

  Currency[Currency["DZD"] = 12] = "DZD";
  /**
   * Egyptian Pound
   *
   * @generated from protobuf enum value: EGP = 818;
   */

  Currency[Currency["EGP"] = 818] = "EGP";
  /**
   * Nakfa
   *
   * @generated from protobuf enum value: ERN = 232;
   */

  Currency[Currency["ERN"] = 232] = "ERN";
  /**
   * Ethiopian Birr
   *
   * @generated from protobuf enum value: ETB = 230;
   */

  Currency[Currency["ETB"] = 230] = "ETB";
  /**
   * Fiji Dollar
   *
   * @generated from protobuf enum value: FJD = 242;
   */

  Currency[Currency["FJD"] = 242] = "FJD";
  /**
   * Falkland Islands Pound
   *
   * @generated from protobuf enum value: FKP = 238;
   */

  Currency[Currency["FKP"] = 238] = "FKP";
  /**
   * Lari
   *
   * @generated from protobuf enum value: GEL = 981;
   */

  Currency[Currency["GEL"] = 981] = "GEL";
  /**
   * Ghana Cedi
   *
   * @generated from protobuf enum value: GHS = 936;
   */

  Currency[Currency["GHS"] = 936] = "GHS";
  /**
   * Gibraltar Pound
   *
   * @generated from protobuf enum value: GIP = 292;
   */

  Currency[Currency["GIP"] = 292] = "GIP";
  /**
   * Dalasi
   *
   * @generated from protobuf enum value: GMD = 270;
   */

  Currency[Currency["GMD"] = 270] = "GMD";
  /**
   * Guinea Franc
   *
   * @generated from protobuf enum value: GNF = 324;
   */

  Currency[Currency["GNF"] = 324] = "GNF";
  /**
   * Guyana Dollar
   *
   * @generated from protobuf enum value: GYD = 328;
   */

  Currency[Currency["GYD"] = 328] = "GYD";
  /**
   * Lempira
   *
   * @generated from protobuf enum value: HNL = 340;
   */

  Currency[Currency["HNL"] = 340] = "HNL";
  /**
   * Kuna
   *
   * @generated from protobuf enum value: HRK = 191;
   */

  Currency[Currency["HRK"] = 191] = "HRK";
  /**
   * Gourde
   *
   * @generated from protobuf enum value: HTG = 332;
   */

  Currency[Currency["HTG"] = 332] = "HTG";
  /**
   * Rupiah
   *
   * @generated from protobuf enum value: IDR = 360;
   */

  Currency[Currency["IDR"] = 360] = "IDR";
  /**
   * Iraqi Dinar
   *
   * @generated from protobuf enum value: IQD = 368;
   */

  Currency[Currency["IQD"] = 368] = "IQD";
  /**
   * Iranian Rial
   *
   * @generated from protobuf enum value: IRR = 364;
   */

  Currency[Currency["IRR"] = 364] = "IRR";
  /**
   * Jamaican Dollar
   *
   * @generated from protobuf enum value: JMD = 388;
   */

  Currency[Currency["JMD"] = 388] = "JMD";
  /**
   * Jordanian Dinar
   *
   * @generated from protobuf enum value: JOD = 400;
   */

  Currency[Currency["JOD"] = 400] = "JOD";
  /**
   * Kenyan Shilling
   *
   * @generated from protobuf enum value: KES = 404;
   */

  Currency[Currency["KES"] = 404] = "KES";
  /**
   * Som
   *
   * @generated from protobuf enum value: KGS = 417;
   */

  Currency[Currency["KGS"] = 417] = "KGS";
  /**
   * Riel
   *
   * @generated from protobuf enum value: KHR = 116;
   */

  Currency[Currency["KHR"] = 116] = "KHR";
  /**
   * Comoro Franc
   *
   * @generated from protobuf enum value: KMF = 174;
   */

  Currency[Currency["KMF"] = 174] = "KMF";
  /**
   * North Korean Won
   *
   * @generated from protobuf enum value: KPW = 408;
   */

  Currency[Currency["KPW"] = 408] = "KPW";
  /**
   * Kuwaiti Dinar
   *
   * @generated from protobuf enum value: KWD = 414;
   */

  Currency[Currency["KWD"] = 414] = "KWD";
  /**
   * Cayman Islands Dollar
   *
   * @generated from protobuf enum value: KYD = 136;
   */

  Currency[Currency["KYD"] = 136] = "KYD";
  /**
   * Kip
   *
   * @generated from protobuf enum value: LAK = 418;
   */

  Currency[Currency["LAK"] = 418] = "LAK";
  /**
   * Lebanese Pound
   *
   * @generated from protobuf enum value: LBP = 422;
   */

  Currency[Currency["LBP"] = 422] = "LBP";
  /**
   * Sri Lanka Rupee
   *
   * @generated from protobuf enum value: LKR = 144;
   */

  Currency[Currency["LKR"] = 144] = "LKR";
  /**
   * Liberian Dollar
   *
   * @generated from protobuf enum value: LRD = 430;
   */

  Currency[Currency["LRD"] = 430] = "LRD";
  /**
   * Loti
   *
   * @generated from protobuf enum value: LSL = 426;
   */

  Currency[Currency["LSL"] = 426] = "LSL";
  /**
   * Libyan Dinar
   *
   * @generated from protobuf enum value: LYD = 434;
   */

  Currency[Currency["LYD"] = 434] = "LYD";
  /**
   * Moroccan Dirham
   *
   * @generated from protobuf enum value: MAD = 504;
   */

  Currency[Currency["MAD"] = 504] = "MAD";
  /**
   * Moldovan Leu
   *
   * @generated from protobuf enum value: MDL = 498;
   */

  Currency[Currency["MDL"] = 498] = "MDL";
  /**
   * Malagasy Ariary
   *
   * @generated from protobuf enum value: MGA = 969;
   */

  Currency[Currency["MGA"] = 969] = "MGA";
  /**
   * Denar
   *
   * @generated from protobuf enum value: MKD = 807;
   */

  Currency[Currency["MKD"] = 807] = "MKD";
  /**
   * Kyat
   *
   * @generated from protobuf enum value: MMK = 104;
   */

  Currency[Currency["MMK"] = 104] = "MMK";
  /**
   * Tugrik
   *
   * @generated from protobuf enum value: MNT = 496;
   */

  Currency[Currency["MNT"] = 496] = "MNT";
  /**
   * Pataca
   *
   * @generated from protobuf enum value: MOP = 446;
   */

  Currency[Currency["MOP"] = 446] = "MOP";
  /**
   * Ouguiya
   *
   * @generated from protobuf enum value: MRO = 478;
   */

  Currency[Currency["MRO"] = 478] = "MRO";
  /**
   * Mauritius Rupee
   *
   * @generated from protobuf enum value: MUR = 480;
   */

  Currency[Currency["MUR"] = 480] = "MUR";
  /**
   * Rufiyaa
   *
   * @generated from protobuf enum value: MVR = 462;
   */

  Currency[Currency["MVR"] = 462] = "MVR";
  /**
   * Malawi Kwacha
   *
   * @generated from protobuf enum value: MWK = 454;
   */

  Currency[Currency["MWK"] = 454] = "MWK";
  /**
   * Malaysian Ringgit
   *
   * @generated from protobuf enum value: MYR = 458;
   */

  Currency[Currency["MYR"] = 458] = "MYR";
  /**
   * Mozambique Metical
   *
   * @generated from protobuf enum value: MZN = 943;
   */

  Currency[Currency["MZN"] = 943] = "MZN";
  /**
   * Namibia Dollar
   *
   * @generated from protobuf enum value: NAD = 516;
   */

  Currency[Currency["NAD"] = 516] = "NAD";
  /**
   * Naira
   *
   * @generated from protobuf enum value: NGN = 566;
   */

  Currency[Currency["NGN"] = 566] = "NGN";
  /**
   * Cordoba Oro
   *
   * @generated from protobuf enum value: NIO = 558;
   */

  Currency[Currency["NIO"] = 558] = "NIO";
  /**
   * Nepalese Rupee
   *
   * @generated from protobuf enum value: NPR = 524;
   */

  Currency[Currency["NPR"] = 524] = "NPR";
  /**
   * Rial Omani
   *
   * @generated from protobuf enum value: OMR = 512;
   */

  Currency[Currency["OMR"] = 512] = "OMR";
  /**
   * Balboa
   *
   * @generated from protobuf enum value: PAB = 590;
   */

  Currency[Currency["PAB"] = 590] = "PAB";
  /**
   * Sol
   *
   * @generated from protobuf enum value: PEN = 604;
   */

  Currency[Currency["PEN"] = 604] = "PEN";
  /**
   * Kina
   *
   * @generated from protobuf enum value: PGK = 598;
   */

  Currency[Currency["PGK"] = 598] = "PGK";
  /**
   * Philippine Peso
   *
   * @generated from protobuf enum value: PHP = 608;
   */

  Currency[Currency["PHP"] = 608] = "PHP";
  /**
   * Pakistan Rupee
   *
   * @generated from protobuf enum value: PKR = 586;
   */

  Currency[Currency["PKR"] = 586] = "PKR";
  /**
   * Guarani
   *
   * @generated from protobuf enum value: PYG = 600;
   */

  Currency[Currency["PYG"] = 600] = "PYG";
  /**
   * Qatari Rial
   *
   * @generated from protobuf enum value: QAR = 634;
   */

  Currency[Currency["QAR"] = 634] = "QAR";
  /**
   * Romanian Leu
   *
   * @generated from protobuf enum value: RON = 946;
   */

  Currency[Currency["RON"] = 946] = "RON";
  /**
   * Serbian Dinar
   *
   * @generated from protobuf enum value: RSD = 941;
   */

  Currency[Currency["RSD"] = 941] = "RSD";
  /**
   * Rwanda Franc
   *
   * @generated from protobuf enum value: RWF = 646;
   */

  Currency[Currency["RWF"] = 646] = "RWF";
  /**
   * Saudi Riyal
   *
   * @generated from protobuf enum value: SAR = 682;
   */

  Currency[Currency["SAR"] = 682] = "SAR";
  /**
   * Solomon Islands Dollar
   *
   * @generated from protobuf enum value: SBD = 90;
   */

  Currency[Currency["SBD"] = 90] = "SBD";
  /**
   * Seychelles Rupee
   *
   * @generated from protobuf enum value: SCR = 690;
   */

  Currency[Currency["SCR"] = 690] = "SCR";
  /**
   * Sudanese Pound
   *
   * @generated from protobuf enum value: SDG = 938;
   */

  Currency[Currency["SDG"] = 938] = "SDG";
  /**
   * Saint Helena Pound
   *
   * @generated from protobuf enum value: SHP = 654;
   */

  Currency[Currency["SHP"] = 654] = "SHP";
  /**
   * Leone
   *
   * @generated from protobuf enum value: SLL = 694;
   */

  Currency[Currency["SLL"] = 694] = "SLL";
  /**
   * Somali Shilling
   *
   * @generated from protobuf enum value: SOS = 706;
   */

  Currency[Currency["SOS"] = 706] = "SOS";
  /**
   * Surinam Dollar
   *
   * @generated from protobuf enum value: SRD = 968;
   */

  Currency[Currency["SRD"] = 968] = "SRD";
  /**
   * South Sudanese Pound
   *
   * @generated from protobuf enum value: SSP = 728;
   */

  Currency[Currency["SSP"] = 728] = "SSP";
  /**
   * Dobra
   *
   * @generated from protobuf enum value: STD = 678;
   */

  Currency[Currency["STD"] = 678] = "STD";
  /**
   * Syrian Pound
   *
   * @generated from protobuf enum value: SYP = 760;
   */

  Currency[Currency["SYP"] = 760] = "SYP";
  /**
   * Lilangeni
   *
   * @generated from protobuf enum value: SZL = 748;
   */

  Currency[Currency["SZL"] = 748] = "SZL";
  /**
   * Somoni
   *
   * @generated from protobuf enum value: TJS = 972;
   */

  Currency[Currency["TJS"] = 972] = "TJS";
  /**
   * Turkmenistan New Manat
   *
   * @generated from protobuf enum value: TMT = 934;
   */

  Currency[Currency["TMT"] = 934] = "TMT";
  /**
   * Tunisian Dinar
   *
   * @generated from protobuf enum value: TND = 788;
   */

  Currency[Currency["TND"] = 788] = "TND";
  /**
   * Pa’anga
   *
   * @generated from protobuf enum value: TOP = 776;
   */

  Currency[Currency["TOP"] = 776] = "TOP";
  /**
   * Trinidad and Tobago Dollar
   *
   * @generated from protobuf enum value: TTD = 780;
   */

  Currency[Currency["TTD"] = 780] = "TTD";
  /**
   * Tanzanian Shilling
   *
   * @generated from protobuf enum value: TZS = 834;
   */

  Currency[Currency["TZS"] = 834] = "TZS";
  /**
   * Uganda Shilling
   *
   * @generated from protobuf enum value: UGX = 800;
   */

  Currency[Currency["UGX"] = 800] = "UGX";
  /**
   * Peso Uruguayo
   *
   * @generated from protobuf enum value: UYU = 858;
   */

  Currency[Currency["UYU"] = 858] = "UYU";
  /**
   * Uzbekistan Sum
   *
   * @generated from protobuf enum value: UZS = 860;
   */

  Currency[Currency["UZS"] = 860] = "UZS";
  /**
   * Bolivar
   *
   * @generated from protobuf enum value: VEF = 937;
   */

  Currency[Currency["VEF"] = 937] = "VEF";
  /**
   * Dong
   *
   * @generated from protobuf enum value: VND = 704;
   */

  Currency[Currency["VND"] = 704] = "VND";
  /**
   * Vatu
   *
   * @generated from protobuf enum value: VUV = 548;
   */

  Currency[Currency["VUV"] = 548] = "VUV";
  /**
   * Tala
   *
   * @generated from protobuf enum value: WST = 882;
   */

  Currency[Currency["WST"] = 882] = "WST";
  /**
   * CFA Franc BEAC
   *
   * @generated from protobuf enum value: XAF = 950;
   */

  Currency[Currency["XAF"] = 950] = "XAF";
  /**
   * East Caribbean Dollar
   *
   * @generated from protobuf enum value: XCD = 951;
   */

  Currency[Currency["XCD"] = 951] = "XCD";
  /**
   * CFA Franc BCEAO
   *
   * @generated from protobuf enum value: XOF = 952;
   */

  Currency[Currency["XOF"] = 952] = "XOF";
  /**
   * CFP Franc
   *
   * @generated from protobuf enum value: XPF = 953;
   */

  Currency[Currency["XPF"] = 953] = "XPF";
  /**
   * Yemeni Rial
   *
   * @generated from protobuf enum value: YER = 886;
   */

  Currency[Currency["YER"] = 886] = "YER";
  /**
   * Zambian Kwacha
   *
   * @generated from protobuf enum value: ZMW = 967;
   */

  Currency[Currency["ZMW"] = 967] = "ZMW";
  /**
   * Zimbabwe Dollar
   *
   * @generated from protobuf enum value: ZWL = 932;
   */

  Currency[Currency["ZWL"] = 932] = "ZWL";
  /**
   * Mvdol
   *
   * @generated from protobuf enum value: BOV = 984;
   */

  Currency[Currency["BOV"] = 984] = "BOV";
  /**
   * Belarusian Ruble
   *
   * @generated from protobuf enum value: BYN = 933;
   */

  Currency[Currency["BYN"] = 933] = "BYN";
  /**
   * WIR Euro
   *
   * @generated from protobuf enum value: CHE = 947;
   */

  Currency[Currency["CHE"] = 947] = "CHE";
  /**
   * WIR Franc
   *
   * @generated from protobuf enum value: CHW = 948;
   */

  Currency[Currency["CHW"] = 948] = "CHW";
  /**
   * Unidad de Fomento
   *
   * @generated from protobuf enum value: CLF = 990;
   */

  Currency[Currency["CLF"] = 990] = "CLF";
  /**
   * Unidad de Valor Real
   *
   * @generated from protobuf enum value: COU = 970;
   */

  Currency[Currency["COU"] = 970] = "COU";
  /**
   * Peso Convertible
   *
   * @generated from protobuf enum value: CUC = 931;
   */

  Currency[Currency["CUC"] = 931] = "CUC";
  /**
   * Mexican Unidad de Inversion (UDI)
   *
   * @generated from protobuf enum value: MXV = 979;
   */

  Currency[Currency["MXV"] = 979] = "MXV";
  /**
   * El Salvador Colon
   *
   * @generated from protobuf enum value: SVC = 222;
   */

  Currency[Currency["SVC"] = 222] = "SVC";
  /**
   * US Dollar (Next day)
   *
   * @generated from protobuf enum value: USN = 997;
   */

  Currency[Currency["USN"] = 997] = "USN";
  /**
   * Uruguay Peso en Unidades Indexadas (
   *
   * @generated from protobuf enum value: UYI = 940;
   */

  Currency[Currency["UYI"] = 940] = "UYI";
  /**
   * Bond Markets Unit European Composite
   *
   * @generated from protobuf enum value: XBA = 955;
   */

  Currency[Currency["XBA"] = 955] = "XBA";
  /**
   * Bond Markets Unit European Monetary
   *
   * @generated from protobuf enum value: XBB = 956;
   */

  Currency[Currency["XBB"] = 956] = "XBB";
  /**
   * Bond Markets Unit European Unit of A
   *
   * @generated from protobuf enum value: XBC = 957;
   */

  Currency[Currency["XBC"] = 957] = "XBC";
  /**
   * Bond Markets Unit European Unit of A
   *
   * @generated from protobuf enum value: XBD = 958;
   */

  Currency[Currency["XBD"] = 958] = "XBD";
  /**
   * SDR (Special Drawing Right)
   *
   * @generated from protobuf enum value: XDR = 960;
   */

  Currency[Currency["XDR"] = 960] = "XDR";
  /**
   * Palladium
   *
   * @generated from protobuf enum value: XPD = 964;
   */

  Currency[Currency["XPD"] = 964] = "XPD";
  /**
   * Platinum
   *
   * @generated from protobuf enum value: XPT = 962;
   */

  Currency[Currency["XPT"] = 962] = "XPT";
  /**
   * Sucre
   *
   * @generated from protobuf enum value: XSU = 994;
   */

  Currency[Currency["XSU"] = 994] = "XSU";
  /**
   * Codes specifically reserved for test
   *
   * @generated from protobuf enum value: XTS = 963;
   */

  Currency[Currency["XTS"] = 963] = "XTS";
  /**
   * ADB Unit of Account
   *
   * @generated from protobuf enum value: XUA = 965;
   */

  Currency[Currency["XUA"] = 965] = "XUA";
  /**
   * The codes assigned for transactions
   *
   * @generated from protobuf enum value: XXX = 999;
   */

  Currency[Currency["XXX"] = 999] = "XXX";
  /**
   * Spanish peseta
   *
   * @generated from protobuf enum value: ESP = 724;
   */

  Currency[Currency["ESP"] = 724] = "ESP";
  /**
   * Venezuelan bolívar soberano
   *
   * @generated from protobuf enum value: VES = 928;
   */

  Currency[Currency["VES"] = 928] = "VES";
  /**
   * Mauritanian ouguiya
   *
   * @generated from protobuf enum value: MRU = 929;
   */

  Currency[Currency["MRU"] = 929] = "MRU";
  /**
   * Not ISO currency
   *
   * Penny Sterling
   *
   * @generated from protobuf enum value: GBX = 10000;
   */

  Currency[Currency["GBX"] = 10000] = "GBX";
  /**
   * Chinese yuan
   *
   * @generated from protobuf enum value: CNH = 10001;
   */

  Currency[Currency["CNH"] = 10001] = "CNH";
  /**
   * Euro Cent
   *
   * @generated from protobuf enum value: EUX = 10002;
   */

  Currency[Currency["EUX"] = 10002] = "EUX";
  /**
   * US Cent
   *
   * @generated from protobuf enum value: USX = 10003;
   */

  Currency[Currency["USX"] = 10003] = "USX";
  /**
   * Cryptocurrency top 20 on coinmarketcap.com
   *
   * Bitcoin
   *
   * @generated from protobuf enum value: CCBTC = 100000;
   */

  Currency[Currency["CCBTC"] = 100000] = "CCBTC";
  /**
   * Ethereum
   *
   * @generated from protobuf enum value: CCETH = 100001;
   */

  Currency[Currency["CCETH"] = 100001] = "CCETH";
  /**
   * Bitcoin Cash
   *
   * @generated from protobuf enum value: CCBCH = 100002;
   */

  Currency[Currency["CCBCH"] = 100002] = "CCBCH";
  /**
   * Ripple
   *
   * @generated from protobuf enum value: CCXRP = 100003;
   */

  Currency[Currency["CCXRP"] = 100003] = "CCXRP";
  /**
   * Litecoin
   *
   * @generated from protobuf enum value: CCLTC = 100004;
   */

  Currency[Currency["CCLTC"] = 100004] = "CCLTC";
  /**
   * Dash
   *
   * @generated from protobuf enum value: CCDASH = 100005;
   */

  Currency[Currency["CCDASH"] = 100005] = "CCDASH";
  /**
   * IOTA
   *
   * @generated from protobuf enum value: CCIOT = 100006;
   */

  Currency[Currency["CCIOT"] = 100006] = "CCIOT";
  /**
   * Monero
   *
   * @generated from protobuf enum value: CCXMR = 100007;
   */

  Currency[Currency["CCXMR"] = 100007] = "CCXMR";
  /**
   * NEO
   *
   * @generated from protobuf enum value: CCNEO = 100008;
   */

  Currency[Currency["CCNEO"] = 100008] = "CCNEO";
  /**
   * NEM
   *
   * @generated from protobuf enum value: CCNEM = 100009;
   */

  Currency[Currency["CCNEM"] = 100009] = "CCNEM";
  /**
   * Stellar
   *
   * @generated from protobuf enum value: CCXLM = 100010;
   */

  Currency[Currency["CCXLM"] = 100010] = "CCXLM";
  /**
   * Zcash
   *
   * @generated from protobuf enum value: CCZEC = 100011;
   */

  Currency[Currency["CCZEC"] = 100011] = "CCZEC";
  /**
   * Ethereum Classic
   *
   * @generated from protobuf enum value: CCETC = 100012;
   */

  Currency[Currency["CCETC"] = 100012] = "CCETC";
  /**
   * Lisk
   *
   * @generated from protobuf enum value: CCLSK = 100013;
   */

  Currency[Currency["CCLSK"] = 100013] = "CCLSK";
  /**
   * Hshare
   *
   * @generated from protobuf enum value: CCHSR = 100014;
   */

  Currency[Currency["CCHSR"] = 100014] = "CCHSR";
  /**
   * Qtum
   *
   * @generated from protobuf enum value: CCQTUM = 100015;
   */

  Currency[Currency["CCQTUM"] = 100015] = "CCQTUM";
  /**
   * EOS
   *
   * @generated from protobuf enum value: CCEOS = 100016;
   */

  Currency[Currency["CCEOS"] = 100016] = "CCEOS";
  /**
   * OmiseGO
   *
   * @generated from protobuf enum value: CCOMG = 100017;
   */

  Currency[Currency["CCOMG"] = 100017] = "CCOMG";
  /**
   * Cardano
   *
   * @generated from protobuf enum value: CCADA = 100018;
   */

  Currency[Currency["CCADA"] = 100018] = "CCADA";
  /**
   * Tether
   *
   * @generated from protobuf enum value: CCUSDT = 100019;
   */

  Currency[Currency["CCUSDT"] = 100019] = "CCUSDT";
  /**
   * Bitcoin SV
   *
   * @generated from protobuf enum value: CCBSV = 100035;
   */

  Currency[Currency["CCBSV"] = 100035] = "CCBSV";
  /**
   * Bitcoin Gold
   *
   * @generated from protobuf enum value: CCBTG = 100036;
   */

  Currency[Currency["CCBTG"] = 100036] = "CCBTG";
  /**
   * PAX
   *
   * @generated from protobuf enum value: CCPAX = 100037;
   */

  Currency[Currency["CCPAX"] = 100037] = "CCPAX";
  /**
   * Metaverse ETP
   *
   * @generated from protobuf enum value: CCETP = 100056;
   */

  Currency[Currency["CCETP"] = 100056] = "CCETP";
  /**
   * Tezos
   *
   * @generated from protobuf enum value: CCXTZ = 100113;
   */

  Currency[Currency["CCXTZ"] = 100113] = "CCXTZ";
  /**
   * UDC
   *
   * @generated from protobuf enum value: CCUDC = 100125;
   */

  Currency[Currency["CCUDC"] = 100125] = "CCUDC";
  /**
   * Tron
   *
   * @generated from protobuf enum value: CCTRX = 100130;
   */

  Currency[Currency["CCTRX"] = 100130] = "CCTRX";
  /**
   * Token J2TD (J2T)
   *
   * @generated from protobuf enum value: CCJ2TD = 100131;
   */

  Currency[Currency["CCJ2TD"] = 100131] = "CCJ2TD";
  /**
   * Token USDJ (J2T)
   *
   * @generated from protobuf enum value: CCUSDJ = 100132;
   */

  Currency[Currency["CCUSDJ"] = 100132] = "CCUSDJ";
  /**
   * Token EURJ (J2T)
   *
   * @generated from protobuf enum value: CCEURJ = 100133;
   */

  Currency[Currency["CCEURJ"] = 100133] = "CCEURJ";
  /**
   * Token RUBJ (J2T)
   *
   * @generated from protobuf enum value: CCRUBJ = 100134;
   */

  Currency[Currency["CCRUBJ"] = 100134] = "CCRUBJ";
  /**
   * Wrapped Bitcoin
   *
   * @generated from protobuf enum value: CCWBTC = 100135;
   */

  Currency[Currency["CCWBTC"] = 100135] = "CCWBTC";
  /**
   * The Sandbox
   *
   * @generated from protobuf enum value: CCSAND = 100136;
   */

  Currency[Currency["CCSAND"] = 100136] = "CCSAND";
  /**
   * yearn.finance
   *
   * @generated from protobuf enum value: CCYFI = 100137;
   */

  Currency[Currency["CCYFI"] = 100137] = "CCYFI";
  /**
   * Decentral Games Governance
   *
   * @generated from protobuf enum value: CCXDG = 100138;
   */

  Currency[Currency["CCXDG"] = 100138] = "CCXDG";
  /**
   * PAX Gold
   *
   * @generated from protobuf enum value: CCPAXG = 100139;
   */

  Currency[Currency["CCPAXG"] = 100139] = "CCPAXG";
  /**
   * Maker
   *
   * @generated from protobuf enum value: CCMKR = 100140;
   */

  Currency[Currency["CCMKR"] = 100140] = "CCMKR";
  /**
   * Mina
   *
   * @generated from protobuf enum value: CCMINA = 100141;
   */

  Currency[Currency["CCMINA"] = 100141] = "CCMINA";
  /**
   * Luna
   *
   * @generated from protobuf enum value: CCLUNA = 100142;
   */

  Currency[Currency["CCLUNA"] = 100142] = "CCLUNA";
  /**
   * Loopring
   *
   * @generated from protobuf enum value: CCLRC = 100143;
   */

  Currency[Currency["CCLRC"] = 100143] = "CCLRC";
  /**
   * Chainlink
   *
   * @generated from protobuf enum value: CCLINK = 100144;
   */

  Currency[Currency["CCLINK"] = 100144] = "CCLINK";
  /**
   * Kusama
   *
   * @generated from protobuf enum value: CCKSM = 100145;
   */

  Currency[Currency["CCKSM"] = 100145] = "CCKSM";
  /**
   * Flow
   *
   * @generated from protobuf enum value: CCFLOW = 100146;
   */

  Currency[Currency["CCFLOW"] = 100146] = "CCFLOW";
  /**
   * The Graph
   *
   * @generated from protobuf enum value: CCGRT = 100147;
   */

  Currency[Currency["CCGRT"] = 100147] = "CCGRT";
  /**
   * Filecoin
   *
   * @generated from protobuf enum value: CCFIL = 100148;
   */

  Currency[Currency["CCFIL"] = 100148] = "CCFIL";
  /**
   * Enjin Coin
   *
   * @generated from protobuf enum value: CCENJ = 100149;
   */

  Currency[Currency["CCENJ"] = 100149] = "CCENJ";
  /**
   * Polkadot
   *
   * @generated from protobuf enum value: CCDOT = 100150;
   */

  Currency[Currency["CCDOT"] = 100150] = "CCDOT";
  /**
   * Curve DAO Token
   *
   * @generated from protobuf enum value: CCCRV = 100151;
   */

  Currency[Currency["CCCRV"] = 100151] = "CCCRV";
  /**
   * Compound
   *
   * @generated from protobuf enum value: CCCOMP = 100152;
   */

  Currency[Currency["CCCOMP"] = 100152] = "CCCOMP";
  /**
   * Chiliz
   *
   * @generated from protobuf enum value: CCCHZ = 100153;
   */

  Currency[Currency["CCCHZ"] = 100153] = "CCCHZ";
  /**
   * Basic Attention Token
   *
   * @generated from protobuf enum value: CCBAT = 100154;
   */

  Currency[Currency["CCBAT"] = 100154] = "CCBAT";
  /**
   * Axie Infinity
   *
   * @generated from protobuf enum value: CCAXS = 100155;
   */

  Currency[Currency["CCAXS"] = 100155] = "CCAXS";
  /**
   * Avalanche
   *
   * @generated from protobuf enum value: CCAVAX = 100156;
   */

  Currency[Currency["CCAVAX"] = 100156] = "CCAVAX";
  /**
   * Cosmos
   *
   * @generated from protobuf enum value: CCATOM = 100157;
   */

  Currency[Currency["CCATOM"] = 100157] = "CCATOM";
  /**
   * Algorand
   *
   * @generated from protobuf enum value: CCALGO = 100158;
   */

  Currency[Currency["CCALGO"] = 100158] = "CCALGO";
  /**
   * AAVE
   *
   * @generated from protobuf enum value: CCAAVE = 100159;
   */

  Currency[Currency["CCAAVE"] = 100159] = "CCAAVE";
  /**
   * DAI
   *
   * @generated from protobuf enum value: CCDAI = 100160;
   */

  Currency[Currency["CCDAI"] = 100160] = "CCDAI";
  /**
   * USD Coin
   *
   * @generated from protobuf enum value: CCUSDC = 100161;
   */

  Currency[Currency["CCUSDC"] = 100161] = "CCUSDC";
  /**
   * Binance USD
   *
   * @generated from protobuf enum value: CCBUSD = 100162;
   */

  Currency[Currency["CCBUSD"] = 100162] = "CCBUSD";
  /**
   * Custom crytocurrencies
   *
   * Millibitchoin
   *
   * @generated from protobuf enum value: CCMBTC = 110001;
   */

  Currency[Currency["CCMBTC"] = 110001] = "CCMBTC";
  /**
   * Milliether
   *
   * @generated from protobuf enum value: CCMETH = 110002;
   */

  Currency[Currency["CCMETH"] = 110002] = "CCMETH";
  /**
   * Millibitcoincash
   *
   * @generated from protobuf enum value: CCMBCH = 110003;
   */

  Currency[Currency["CCMBCH"] = 110003] = "CCMBCH";
  /**
   * Millilitecoin
   *
   * @generated from protobuf enum value: CCMLTC = 110004;
   */

  Currency[Currency["CCMLTC"] = 110004] = "CCMLTC";
  /**
   * Custom currencies (precious metals) on Moscow Exchange
   *
   * Gold Loco London
   *
   * @generated from protobuf enum value: GLD = 1000000;
   */

  Currency[Currency["GLD"] = 1000000] = "GLD";
  /**
   * Silver Loco London
   *
   * @generated from protobuf enum value: SLV = 1000001;
   */

  Currency[Currency["SLV"] = 1000001] = "SLV";
})(Currency || (Currency = {}));